export default __webpack_public_path__ + "static/media/tworcy_bar.458c9f07.jpg";